var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgOldestIcon = function SvgOldestIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12V0H3v12H.5L4 15.5 7.5 12zM10.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1H11V2.5a.5.5 0 0 0-.5-.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5c0-2.757 2.243-5 5-5s5 2.243 5 5v.5a.5.5 0 0 1-1 0V5c0-2.206-1.794-4-4-4S7 2.794 7 5a4.01 4.01 0 0 0 3 3.873V7l3 2.5-3 2.5V9.899A5.01 5.01 0 0 1 6 5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOldestIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;